import { Component, Input } from '@angular/core';
import { Report } from '../../../models/report.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-les-moins-read-mode',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './les-moins-read-mode.component.html',
  styleUrl: './les-moins-read-mode.component.scss',
})
export class LesMoinsReadModeComponent {
  @Input() drawbacks!: Report.Drawbacks;
}
